import { Gas } from "@domain/gas/gas";
import { Product } from "@domain/product/product";
import { FlameDetectorConfiguration } from "@domain/project/configurations/flame-detector-configuration";
import { FlameDetectorType } from "@project/flame-detector-configuration/flame-detector-type";

export class OriginalFlameDetectorConfiguration {
  productConfiguration: FlameDetectorConfiguration;
  substance?: Gas;
  family?: FlameDetectorType;
  variant?: Product;
  attachments?: { product: Product; quantity: number }[];

  constructor(
    productConfiguration: FlameDetectorConfiguration,
    substance?: Gas,
    family?: FlameDetectorType,
    variant?: Product,
    attachments?: { product: Product; quantity: number }[],
  ) {
    this.productConfiguration = productConfiguration;
    this.substance = substance;
    this.family = family;
    this.variant = variant;
    this.attachments = attachments;
  }
}
